/*eslint-disable */
import toast from '../../services/toast';
import Vue from 'vue';
import DatePicker from 'vue2-datepicker'
import userImageBox from '../../components/userimage/index';
var $ = window.jQuery = jQuery = require('jquery');
import countries from '../../services/country.json';
import FormData from 'form-data'
import {
  mapGetters,
  mapState
} from 'vuex';
import allCountries from './phoneCodeList.json';
import draggable from 'vuedraggable'
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)
export default {
  name: 'update-user-profile',
  components: {
    'user-image': userImageBox,
    DatePicker,
    draggable,
    Multiselect
  },
  props: [],
  data() {
    return {
      schoolRequired: false,
      countryRequired: false,
      isContestError: false,
      countryList: [],
      allCountriesList: [],
      // profileInfo: [],
      fname: '',
      lname: '',
      date_of_birth: null,
      //phone: '',
      avatar: '',
      organization: '',
      country: '',
      city: '',
      zip: '',
      address: '',
      facebook: '',
      twitter: '',
      linkedin: '',
      othermail: '',

      submitted: false,
      required: true,
      preloader: false,
      image: '',
      imagefile: null,

      passwordModal: false,
      reaarangedModal:false,
      currentpassword: '',
      confirmpassword: '',
      newpassword: '',
      file: null,
      uploadFile:'',
      uploadFileName: '',
      bio :'',
      cv:'',
      fixloader: false,
      phone: {
        number: '',
        isValid: false,
        country: '',
        countryIso: ''
      },
      phoneNumber:{
        key1:'',
        key2:'',
        key3:'',
        key4:'',
        key5:'',
        key6:'',
        key7:'',
        key8:'',
        key9:'',
        key10:'',
      },
      proInfoData:'',
      proInfoDetails:'',
      proInfoMoveId:'',
      proInfoMoveIndex:'',
      proInfo: {
        school:'',
        major:'',
        minor:'',
        organization:'',
        area_of_work:''
      },
      fullnumber:'',
      usaPhoneNumber:false,
      isSuggestionOpen:false,
      suggestionSchoolSearchList:[],
      arrowCounter: 0,

      isWorkdomain: true,
      isWorking: false,
      inEducation: false,
      isCurrentlyWorking: false,
      isProfSkills: true,
      multiselect: false,
      skillsOptions: [
        {option:"Accounting"},
        {option:"African Studies"},
        {option:"American History"},
        {option:"Ancient History"},
        {option:"Anthropology"},
        {option:"Architecture"},
        {option:"Artificial Intelligence"},
        {option:"Biochemistry"},
        {option:"Biology"},
        {option:"Chemistry"},
        {option:"Cinema Studies"},
        {option:"Civil Engineering"},
        {option:"Computer Engineer"},
        {option:"Computer Programming"},
        {option:"Data Science"},
        {option:"Development Economics"},
        {option:"Digital Arts"},
        {option:"Econometrics"},
        {option:"Economics"},
        {option:"Egyptology"},
        {option:"Electrical Engineering"},
        {option:"Electronics & Communication Engineering"},
        {option:"Engineering"},
        {option:"Evolutionary Biology"},
        {option:"Far Eastern History"},
        {option:"Films & Drama"},
        {option:"Finance"},
        {option:"Financial Engineering"},
        {option:"Financial Risk Management"},
        {option:"Fine Arts"},
        {option:"General Relativity"},
        {option:"Geography"},
        {option:"Geology"},
        {option:"History (Middle Ages)"},
        {option:"History of Science"},
        {option:"History"},
        {option:"Hotel Management"},
        {option:"Human Resources Management"},
        {option:"Indian History"},
        {option:"Industrial Engineering"},
        {option:"Inorganic Chemistry"},
        {option:"International Relations"},
        {option:"Journalism"},
        {option:"Language Studies"},
        {option:"Latin American History"},
        {option:"Linguistics"},
        {option:"Literature (American)"},
        {option:"Literature (Bengali)"},
        {option:"Literature (English)"},
        {option:"Literature (French)"},
        {option:"Literature (German)"},
        {option:"Literature (Hindi)"},
        {option:"Literature (Japanese)"},
        {option:"Literature (Latin American)"},
        {option:"Literature (Other Indian)"},
        {option:"Literature (Other)"},
        {option:"Literature (Sanskrit)"},
        {option:"Literature (Spanish)"},
        {option:"Machine Learning"},
        {option:"Management Studies"},
        {option:"Marketing"},
        {option:"Mass Communication"},
        {option:"Mathematical Finance"},
        {option:"Mathematics"},
        {option:"Mechanical Engineering"},
        {option:"Metallurgical Engineering"},
        {option:"Mining Engineering"},
        {option:"Molecular Biology"},
        {option:"Nuclear Medicine"},
        {option:"Nuclear Physics"},
        {option:"Operations Research"},
        {option:"Organic Chemistry"},
        {option:"Physics"},
        {option:"Political Science"},
        {option:"Psychology"},
        {option:"Quantum Mechanics"},
        {option:"Radiology"},
        {option:"Religious Studies"},
        {option:"Software Engineering"},
        {option:"Statistical Mechanics"},
        {option:"Statistics"},
        {option:"String Theory"},
        {option:"Theology"},
        {option:"Theoretical Computer Science"},
        {option:"VFX & Special Effects"}
      ],
      skillInfoByProfSkill:[],
      skillInfo:{
        school:'',
        degree:'',
        organization:'',
        area_of_work:'',
        academic_skill:'',
        work_domain:'',
        professional_skill:'',
        work_type:'',
      },
      academicSkillOptions:[],
      academicSkillValue:[],
      professionalSkillOptions:[],
      professionalSkillValue:[]
    }
  },
  computed: {
    ...mapGetters([
      'getProfileInfo'
    ]),
    ...mapState([
      'profileInfo'
    ]),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        ghostClass: "ghost"
      };
    },
    setValues() {
      let profileData = this.$store.getters.getProfileInfo
      if (profileData) {
        setTimeout(() => {
          if (profileData.first_name != undefined && profileData.first_name != '') {
            this.fname = profileData.first_name
          }
          if (profileData.last_name != undefined && profileData.last_name != '') {
            this.lname = profileData.last_name
          }
          if (profileData.profile.date_of_birth != undefined && profileData.profile.date_of_birth != '') {
            this.date_of_birth = profileData.profile.date_of_birth
          }

          this.date_of_birth = profileData.profile.date_of_birth
          let phoneNumber = profileData.profile.mobile;
          if(phoneNumber){
          let phoneCountry = phoneNumber.split(' ');
          if (phoneCountry && phoneCountry.length > 1) {
            phoneCountry = phoneCountry[0];
            phoneNumber = phoneNumber.replace(phoneCountry, '')
            phoneCountry = phoneCountry.replace('+', '');
          }
          phoneNumber = phoneNumber.replace(/\s+/, "_");
          phoneNumber = phoneNumber.replace(/\s/g, "");
          phoneNumber = phoneNumber.replace("_", " ");

          this.phone.number = phoneNumber.trim()
          // if(phoneCountry == 1){
          //   this.phoneFormat(this.phone.number)
          //   this.usaPhoneNumber = true
          // }
          // console.log(this.phone.number.split(""), "Get Phone Number")
          if(this.phone.number){
            var phone_num_array = this.phone.number.split("")
            this.phoneNumber.key1 = phone_num_array[0]
            this.phoneNumber.key2 = phone_num_array[1]
            this.phoneNumber.key3 = phone_num_array[2]
            this.phoneNumber.key4 = phone_num_array[3]
            this.phoneNumber.key5 = phone_num_array[4]
            this.phoneNumber.key6 = phone_num_array[5]
            this.phoneNumber.key7 = phone_num_array[6]
            this.phoneNumber.key8 = phone_num_array[7]
            this.phoneNumber.key9 = phone_num_array[8]
            this.phoneNumber.key10 = phone_num_array[9]
          }
          this.phone.isValid = true;
          if(phoneCountry){
          this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == phoneCountry)[0].iso2;
          }
          this.phone.country = phoneCountry;
          }
          this.avatar = profileData.avtar
          this.country = profileData.profile.country || '';

          this.city = profileData.profile.city
          this.zip = profileData.profile.pincode
          this.address = profileData.profile.address
          this.facebook = profileData.profile.facebook
          this.twitter = profileData.profile.twitter
          this.linkedin = profileData.profile.linkedin
          //   instagram: profileData.profile.instagram,
          this.othermail = profileData.profile.other_mail;
          if(profileData.profile.date_of_birth){
            let newDate = (profileData.profile.date_of_birth).split('-');
            newDate = newDate[0] + "/" + newDate[1] + "/" + newDate[2];
            newDate = new Date(newDate);
            newDate = newDate.formatFieldDate();
            this.date_of_birth = newDate;
          }
          if(profileData.profile.cv){
          this.uploadFile = profileData.profile.cv.split("/")
          }
          this.uploadFileName = this.uploadFile[6]
          this.proInfoData = profileData.profile.professional_info
            for (var i = 0; i < this.proInfoData.length; i++) {
              this.proInfoDetails = this.proInfoData[i];
              if(this.proInfoDetails.key == 'area_of_work'){
                this.skillInfo.area_of_work = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'organization'){
                this.skillInfo.organization = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'degree'){
                this.skillInfo.degree = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'work_domain'){
                this.skillInfo.work_domain = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'work_domain'){
                this.skillInfo.work_domain = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'work_type'){
                this.skillInfo.work_type = this.proInfoDetails.value
                  if(this.skillInfo.work_type == "Student"){
                    this.isWorking = false
                    this.inEducation = true
                  }else if(this.skillInfo.work_type == 'Working Professional'){
                    this.isWorking = true
                    this.inEducation = true
                  }else{
                    this.isWorking = false
                    this.inEducation = false
                  }
              }
              if(this.proInfoDetails.key == 'school'){
                this.skillInfo.school = this.proInfoDetails.value
              }
              if(this.proInfoDetails.key == 'professional_skill'){
                if(this.proInfoDetails.value){
                  let professionalSkill = JSON.parse(this.proInfoDetails.value)
                  this.skillInfo.professional_skill = professionalSkill
                }
              }
              if(this.proInfoDetails.key == 'academic_skill'){
                if(this.proInfoDetails.value){
                  let academicSkill = JSON.parse(this.proInfoDetails.value)
                  this.skillInfo.academic_skill = academicSkill
                }
              }
            }
        }, 100);
        $('.httploader').hide();
      }

    },
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });

    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    // loop over all of the countries above, restructuring the data to be objects with named keys
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    $('.option-list').click(function(e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $(this).find('ul').slideToggle(100);
      if ($(this).hasClass('open')) {
        $('.dropdown-arrow').text('▼');
      } else {
        $('.dropdown-arrow').text('▲');
      }
    });
    if(this.$route.params.quizError) {
      this.isContestError = true;
    }
    this.setValues;
    setTimeout(() => {
      this.getUserCountry();
    }, 30);
    if(this.isContestError) {
      if(this.country == '' || this.country == null) {
        this.countryRequired = true;
      }
      if(this.proInfo.school == '' || this.proInfo.school == null) {
        this.schoolRequired = true;
      }
    }
    $.fn.autoTab = function() {
      console.log("Here")
      var autoTabOn = true; // yes, it's global. If you turn off auto tabbing on one input, you turn it off for all
      var autoTabbedInputs = this.find('input');
      var almostTabbedInputs = autoTabbedInputs.not(':last-child'); // note we don't attach tabbing event to the last of an input group. If you tab out of there, you have a reason to
      var justAutoTabbed = false;
      var tabKeyDetected = false;
      var revTabKeyDetected = false;
      var inputField = false;
      // init
      var init = function() {
        detectKeyDown();
        detectKeyUp();
      }
      // keydown detection, hijack it if it's in the fields we're looking for
      var detectKeyDown = function() {
        autoTabbedInputs.on('keydown',function(ev){
          // the field that you're in when you keydown might not be the field you're in when you keyup
          inputField = this;
          // detect keystroke in the fields
          ev = ev || event;
          var charCode = null;
          if ("which" in ev)
            charCode = ev.which;
          else if ("keyCode" in e)
            charCode = ev.keyCode;
          else if ("keyCode" in window.event)
            charCode = window.event.keyCode;
          else if ("which" in window.event)
            charCode = window.event.which;
          // if tabbing forward
          if (charCode === 9 && !ev.shiftKey) {
            // if auto tabbing is off, don't change it's behavior
            if (!autoTabOn) {
              return;
            }
            if (justAutoTabbed) {
              ev.preventDefault();
              autoTabOn = false;
            }
            tabKeyDetected = true;
          // if tabbing backward
          } else if (charCode === 9 && ev.shiftKey) {
            revTabKeyDetected = true;
          // backspace key fakes reverse tab
          } else if (charCode === 8 && this.value.length == 0) {
            revTabKeyDetected = true;
            $(this).prev(".phone_number_field_box input").focus();
          // fake tab keystrokes
          } else if (
            charCode === 191                  // "/" - for dates
            ||
            charCode === 111                  // "/" - for dates (numberpad)
            ||
            charCode === 190                  // "." - for IP addresses
            ||
            charCode === 110                  // "." - for IP addresses (numberpad)
            ||
            charCode === 189                  // "-" - for sortcodes
            ||
            charCode === 109                  // "-" - for sortcodes (numberpad)
          ) {
            ev.preventDefault();
            // if we've not yet hit the max chars for this field, and haven't already just auto-tabbed, fake a tab key
            if (!hasHitMaxChars(this) && !justAutoTabbed) {
              $(this).next(".phone_number_field_box input").focus();
            }
          }
          // removed any flag to say we've just auto-tabbed
          justAutoTabbed = false;
        });
      }
      // entering text into auto-tabbed fields
      var detectKeyUp = function() {
        almostTabbedInputs.on('keyup',function(ev){
          // if auto tabbing is off, bug out now
          if (!autoTabOn) {
            return;
          }
          // if the complimentary keydown was a tab key, ignore this event (and reset it for the next keyup)
          if (tabKeyDetected) {
            tabKeyDetected = false;
            return;
          }
          // if we were tabbing backwards, don't jump forwards again!
          if (revTabKeyDetected) {
            revTabKeyDetected = false;
            return;
          }
          // edge case: if you've tabbed from one input group to another, the inputField that was used in keyDown hasn't yet been set
          if (!inputField) {
            return;
          }
          // removed flag to say we've just auto-tabbed
          justAutoTabbed = false;
          // else auto-tab if the field is full
          if (hasHitMaxChars(inputField)) {
            $(inputField).next().focus();
            // we've just auto-tabbed - flag it
            justAutoTabbed = true;
          }
        })
      }
      // detect if a field has hit max chars
      var hasHitMaxChars = function(el) {
        var elObj = $(el);
        var maxFieldLength = elObj.attr('maxlength') || elObj.attr('size');
        var valueLength = el.value.length;
        if (valueLength>=maxFieldLength) {
          return true;
        }
        return false;
      }
      // init function!
      init();
    }
    // set up example
    $('.phone_number_field_box').autoTab();
    var _self = this;
    $(document).click(function(event) {
      if (!$(event.target).closest(".school_suggestion_field_wrp, .suggestion-autocomplete-results").length) {
        _self.isSuggestionOpen = false;
        $('.school_suggestion_field_wrp-search').removeClass("show_search")
        $('.httploader').removeClass("searchLoaderhide")
        $('.routeloader').removeClass("searchLoaderhide")
      }
    });
  },
  methods: {
    chooseCountry(country) {
      const telInput = $(".custom_mobile_number .form-control");
      this.phone.countryIso = country.iso2;
      this.phone.country = country.dialCode;
      // if(country.dialCode == 1){
      //   this.usaPhoneNumber = true
      //   this.phoneFormat(this.phone.number)
      // }else{
      //   this.usaPhoneNumber = false
      // }
      // console.log(country, "Check Country Details")
    },
    // numberPressed(){
    //   this.phoneFormat(this.phone.number)
    // },
    phoneFormat(input) {
      // Strip all characters from the input except digits
      input = input.replace(/\D/g, '');
      // Trim the remaining input to ten characters, to preserve phone number format
      input = input.substring(0, 10);
      // Based upon the length of the string, we add formatting as necessary
      var size = input.length;
      if (size == 0) {
        input = input;
      } else if (size < 4) {
        input = '(' + input;
      } else if (size < 7) {
        input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
      } else {
        input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + ' - ' + input.substring(6, 10);
      }
      return input;
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
          if (self.phone.country == '') {
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.country = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
          }
          if(self.country == '') {
            //self.country = (text.substr(2, 2)).toLowerCase();
          }
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    onSpace() {},
    onInput(formattedNumber, {
      number,
      isValid
    }) {
      this.phone.number = number;
      this.phone.isValid = isValid;
      if (this.phone.isValid == true) {
        $('.custom_mobile_number').attr('aria-invalid', 'true')
      } else {
        $('.custom_mobile_number').attr('aria-invalid', 'false')
      }
    },
    validate: function() {
      this.$validator.validateAll();
    },
    getProfileAgian(){
      this.$store.dispatch('getProfile').then((res) => {
        this.proInfoData = res.data.data.profile.professional_info
      })
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.files = this.$refs.file.files[0];
        this.file = this.$refs.file.files[0].size;
        this.uploadFileName = this.files.name
        let formData = new FormData();
        formData.append('cv', this.files);
        this.$store.dispatch('cvFileUpdateFun', formData, { headers: {'Content-Type': 'multipart/form-data'}})
          .then((res) => {
            if (res.status == '200') {
              toast.success(res.data.msg);
            }
          })
          .catch((err) => {})
      } else {
        this.uploadFileName = '';
      }
    },
    cvRemoveFun(){
      this.$store.dispatch('cvFileRemoveFun')
          .then((res) => {
            if (res.status == '200') {
              toast.success(res.data.msg);
              this.getProfileAgian()
              this.uploadFileName = ''
            }
          })
          .catch((err) => {})
    },
    validateBeforeSubmit() {
      this.fixloader = true;
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if (result) {
          // let phoneNumber = this.phone.number;
          let phoneNumber = this.phoneNumber.key1 + this.phoneNumber.key2 + this.phoneNumber.key3 + this.phoneNumber.key4 + this.phoneNumber.key5 + this.phoneNumber.key6 + this.phoneNumber.key7 + this.phoneNumber.key8 + this.phoneNumber.key9 + this.phoneNumber.key10
          phoneNumber = phoneNumber.replace(/\s+/, "_");
          phoneNumber = phoneNumber.replace(/\s/g, "");
          phoneNumber = phoneNumber.replace("_", " ");
          let data = {
            first_name: this.fname,
            last_name: this.lname,
            profile: {
              country: this.country,
              mobile: this.fullnumber,
              address: this.address,
              city: this.city,
              pincode: this.zip,
              othermail: this.othermail
            }
          }
          if(phoneNumber != null && phoneNumber != ''){
            this.fullnumber = '+' + this.phone.country + ' ' + phoneNumber
            data.profile['mobile'] = this.fullnumber;
          }
          if(this.country != ''){
            data.profile['country'] = this.country;
          }
          if(this.address != ''){
            data.profile['address'] = this.address;
          }
          if(this.date_of_birth  != '' && this.date_of_birth != null ){
              let newDate = (this.date_of_birth).split('-');
              newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];
              newDate = newDate.replace(/-/g, '/');
              newDate = new Date(newDate);
              newDate = newDate.formatDate();
              data.profile['date_of_birth'] = newDate;
          }else{
            data.profile['date_of_birth'] = null;
          }
          this.$store.dispatch('updateProfile', data)
            .then((response) => {
              if (response.status == 200) {
                toast.success(response.data.msg);
                this.preloader = false;
                this.$router.push('/profile');
                this.fixloader = false;
              }
            }).catch((error) => {
            })
          return
        }
      })
    },
    showPasswordModal() {
      this.passwordModal = true;
      $('body').addClass('showoverlay');
    },

    closePasswordModal() {
      this.passwordModal = false;
      $('body').removeClass('showoverlay');
    },
    showReaarangedModal() {
      this.reaarangedModal = true;
      $('body').addClass('showoverlay');
    },

    closeReaarangedModal() {
      this.reaarangedModal = false;
      $('body').removeClass('showoverlay');
    },

    validUpdatePassword() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newpassword === this.confirmpassword) {
            let passwordData = {
              password: this.currentpassword,
              new_password: this.newpassword
            }
            this.$store.dispatch('updatePassword', passwordData).then((res) => {
              if (res.status == 200) {
                this.passwordModal = false;
                $('body').removeClass('showoverlay');
                this.$validator.reset();
                this.currentpassword = '';
                this.confirmpassword = '';
                this.newpassword = '';
              }
            }).catch((err) => {})
          } else {
            toast.error('New password and Confirm password are not same.');
          }
          return;
        }
        toast.error('Please fix the errors');
      });
    },
    infoCheckMove: function(event) {
      this.proInfoMoveindex = event.moved.newIndex + 1
      this.proInfoMoveId = event.moved.element.id
      let data = {
        index: this.proInfoMoveindex
      }
      this.$store.dispatch('userProInfoByIndex', {
        data: {
          data: data,
          id: this.proInfoMoveId
        }
      }).then((res) => {
        if (res.status == '200') {
          toast.success(res.data.msg);
          this.getProfileAgian()
        }
      }).catch((err) => {})
    },
    onChangeSuggestionFilters(){
      $('.school_suggestion_field_wrp').addClass("show_search")
      if(this.skillInfo.school.length >= 2){
        $('.httploader').addClass("searchLoaderhide")
        $('.routeloader').addClass("searchLoaderhide")
        this.isSuggestionOpen = true;
        this.$store.dispatch('schoolSuggestionFiltersUrl', { search_term: this.skillInfo.school }).then((response) => {
            this.suggestionSchoolSearchList = response.data.data
        })
      }else{
        this.isSuggestionOpen = false;
      }
    },
    selectedSuggestionNameFun(name){
      this.skillInfo.school = name
      this.isSuggestionOpen = false;
      $('.school_suggestion_field_wrp').removeClass("show_search")
    },
    onEnter() {
      this.proInfo.school = this.suggestionSchoolSearchList[this.arrowCounter];
      this.isSuggestionOpen = false;
      this.arrowCounter = -1;
    },
    onArrowDown(evt) {
      if (this.arrowCounter < this.suggestionSchoolSearchList.length) {
        this.arrowCounter = this.arrowCounter + 1;
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1;
      }
    },

    // function related to Multiselect
    // addSkills (newTag) {
    //   const tag = {
    //     name: newTag,
    //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
    //   }
    //   this.skillsOptions.push(tag)
    //   this.skillsValue.push(tag) 
    // },
    // addInterest (newTag) {
    //   const tag = {
    //     name: newTag,
    //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
    //   }
    //   this.interestsOption.push(tag)
    //   this.interestsValue.push(tag) 
    // },

    // function related to Multiselect end
    proInfoUpdate(){
      this.$validator.validateAll().then((result) => {
        var proSlillField, academicSlillField, workDomainState
        if(this.skillInfo.work_type == 'Working Professional'){
          academicSlillField = ''
          workDomainState = this.skillInfo.work_domain
          if(this.skillInfo.professional_skill.length > 0){
            proSlillField = JSON.stringify(this.skillInfo.professional_skill)
          }else{
            proSlillField = ''
          }
        }
        if(this.skillInfo.work_type == 'Student'){
          proSlillField = ''
          workDomainState = ''
          if(this.skillInfo.academic_skill.length > 0){
            academicSlillField = JSON.stringify(this.skillInfo.academic_skill)
          }else{
            academicSlillField = ''
          }
        }
        if (result) {
        let infodData = {
          profile: {
            professional_info: [
            {
              key : 'work_type',
              value: this.skillInfo.work_type,
            },
            {
              key : 'work_domain',
              value: workDomainState,
            },
            {
              key : 'school',
              value: this.skillInfo.school,
            },
            {
              key : 'organization',
              value: this.skillInfo.organization,
            },
            {
              key : 'degree',
              value: this.skillInfo.degree,
            },
            {
              key : 'area_of_work',
              value: this.skillInfo.area_of_work,
            },
            {
              key : 'academic_skill',
              value: academicSlillField,
            },
            {
              key : 'professional_skill',
              value: proSlillField,
            }]
          }
        }
        this.$store.dispatch('userProInfo', infodData).then((res) => {
          toast.success(res.data.msg);
          this.$router.push('/profile');
        }).catch((err) => {})
     }
     });
    },
    onChangeWorkType() {
      if(this.skillInfo.work_type == "Student"){
        this.isWorking = false
        this.inEducation = true
      }else if(this.skillInfo.work_type == 'Working Professional'){
        this.isWorking = true
        this.inEducation = true
      }else{
        this.isWorking = false
        this.inEducation = false
      }
    },
    onChangeWorkDomain() {
      this.skillInfo.professional_skill = ''
      this.isProfSkills = false
        let FinanceAccounting = [
          {value: 1, text:"Asset Management"},
          {value: 1, text:"Economics (Banking)"},
          {value: 1, text:"Equity Analysis"},
          {value: 1, text:"Financial Management"},
          {value: 1, text:"Hedge Fund"},
          {value: 1, text:"Management"},
          {value: 1, text:"Portfolio Management"},
          {value: 1, text:"Securities Trading"},
          {value: "AccountingBanking", text:"Accounting (Banking)"},
          {value: "Banking", text:"Banking"},
          {value: "InvestmentBanking", text:"Investment Banking"},
          {value: "QuantQuantitativeAnalysts", text:"Quant (Quantitative Analysts)"},
          {value: "StructuringandSales", text:"Structuring and Sales"}
        ]
        let Healthcare = [
          {value: 1, text:"Biochemistry"},
          {value: 1, text:"Cardiology (Doctor)"},
          {value: 1, text:"Dentistry (Doctor)"},
          {value: 1, text:"General Medicine (Doctor)"},
          {value: 1, text:"Gynecology (Doctor)"},
          {value: 1, text:"Nuclear Medicine (Doctor)"},
          {value: 1, text:"Nuclear Medicine (Physicist/Technologist)"},
          {value: 1, text:"Nursing"},
          {value: 1, text:"Oncology & Hematology (Doctor)"},
          {value: 1, text:"Pathology"},
          {value: 1, text:"Pharmacology"},
          {value: 1, text:"Radiology (Doctor)"},
          {value: 1, text:"Radiotherapy (Doctor)"},
          {value: 1, text:"Surgery (Doctor)"},
          {value: 1, text:"Urology (Doctor)"}
        ]
        let Legal = [
          {value: 1, text:"Civil Law"},
          {value: 1, text:"Constitutional Law"},
          {value: 1, text:"Corporate Law"},
          {value: 1, text:"Criminal Law"}
        ]
        let BusinessManagementMarketing = [
          {value: 1, text:"Accounting (Corporate)"},
          {value: 1, text:"Advertising"},
          {value: 1, text:"Entrepreneurship"},
          {value: 1, text:"Management (Middle Level & Junior)"},
          {value: 1, text:"Management (Senior)"},
          {value: 1, text:"Management (Start Up)"},
          {value: 1, text:"Sales & Marketing"}
        ]
        let ManufacturingConstructionIndustrial = [
          {value: 1, text:"Architecture"},
          {value: 1, text:"Engineering (Civil)"},
          {value: 1, text:"Engineering (Design)"},
          {value: 1, text:"Engineering (Electrical & Electronics)"},
          {value: 1, text:"Engineering (Industrial)"},
          {value: 1, text:"Engineering (Mechanical)"},
          {value: 1, text:"Engineering (Production)"}
        ]
        let LiteratureArtsFineArts = [
          {value: 1, text:"Cartographer and Surveyor"},
          {value: 1, text:"History"},
          {value: 1, text:"Journalism"},
          {value: 1, text:"Survey Researcher and Urban Planners"},
          {value: 1, text:"Theologist or Theologian"},
          {value: 1, text:"Writing (Novelist/Author)"}
        ]
        let Education = [
          {value: 1, text:"Education"},
          {value: 1, text:"Linguistics"},
          {value: 1, text:"Teaching (College and University)"},
          {value: 1, text:"Teaching (School)"}
        ]
        let ITComputerScience = [
          {value: 1, text:"Computer Engineering"},
          {value: 1, text:"Computer Programming"},
          {value: 1, text:"Data Analysis"},
          {value: 1, text:"Software Development"},
          {value: 1, text:"Software Engineering"},
          {value: 1, text:"Theoretical Computer Science"},
          {value: 1, text:"UX/UI Design"},
          {value: 1, text:"Web Development (Back End)"},
          {value: 1, text:"Web Development (Front End)"}
        ]
        let ArtificialIntelligenceMachineLearning = [
          {value: 1, text:"AI & Machine Learning Research"},
          {value: 1, text:"AI Engineering"},
          {value: 1, text:"Data Scientist"},
          {value: 1, text:"Machine Learning Engineering"}
        ]
        let Films = [
          {value: 1, text:"Acting (Movies)"},
          {value: 1, text:"Acting (Theatre)"},
          {value: 1, text:"Choreography"},
          {value: 1, text:"Cinematography"},
          {value: 1, text:"Digital Arts"},
          {value: 1, text:"Directing (Theatre)"},
          {value: 1, text:"Film Direction"},
          {value: 1, text:"Film Editing"},
          {value: 1, text:"Film Production Technology"},
          {value: 1, text:"Filmmaking"},
          {value: 1, text:"Play writing"},
          {value: 1, text:"Screen Writing"},
          {value: 1, text:"VFX"},
          {value: 1, text:"Videography"},
          {value: 1, text:"YouTubing"}
        ]
        let CorporateRD = [
          {value: 1, text:"Academic Research (Ph.D.)"},
          {value: 1, text:"Academic Research (Post-Doctorate)"},
          {value: 1, text:"Corporate Research & Development"},
          {value: 1, text:"Industrial Research"},
          {value: 1, text:"Natural"}
        ]
        let Others = [
          {value: 1, text:"Hospitality Management"},
          {value: 1, text:"Hotel Management"},
          {value: 1, text:"Logistics "},
          {value: 1, text:"Psychiatry"},
          {value: 1, text:"Social Commentary"}
        ]
        if(this.skillInfo.work_domain == "Finance & Accounting"){
          this.skillInfoByProfSkill = FinanceAccounting;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Healthcare"){
          this.skillInfoByProfSkill = Healthcare;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Legal"){
          this.skillInfoByProfSkill = Legal;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Business, Management & Marketing"){
          this.skillInfoByProfSkill = BusinessManagementMarketing;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Education"){
          this.skillInfoByProfSkill = Education;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Computer Science"){
          this.skillInfoByProfSkill = ITComputerScience;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Artificial Intelligence & Machine Learning"){
          this.skillInfoByProfSkill = ArtificialIntelligenceMachineLearning;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Films"){
          this.skillInfoByProfSkill = Films;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Manufacturing"){
          this.skillInfoByProfSkill = ManufacturingConstructionIndustrial;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Literature, Arts & Fine Arts"){
          this.skillInfoByProfSkill = LiteratureArtsFineArts;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Corporate R&D"){
          this.skillInfoByProfSkill = CorporateRD;
          this.isProfSkills = true
        }
        else if(this.skillInfo.work_domain == "Others"){
          this.skillInfoByProfSkill = Others;
          this.isProfSkills = true
        }
    },
    onChangeProfSkills(profNewTag) {
      console.log(profNewTag, "selected Professional Skills")
    },
  },
  beforeMount() {},
  created() {},
  beforeRouteLeave: function(to, from, next) {
    if (window.localStorage.getItem('t') != null && window.localStorage.getItem('t') != undefined) {
      this.$store.dispatch('getProfile')
    }
    next();
  },
  watch: {
    setValues() {
      let profileData = this.$store.getters.getProfileInfo;
      if (profileData) {
        this.fname = profileData.first_name
        this.lname = profileData.last_name
        this.date_of_birth = profileData.profile.date_of_birth
        this.phone = profileData.profile.mobile
        this.avatar = profileData.avtar
        this.bio = profileData.profile.bio
        this.country = profileData.profile.country
        this.city = profileData.profile.city
        this.zip = profileData.profile.pincode
        this.address = profileData.profile.address
        this.facebook = profileData.profile.facebook
        this.twitter = profileData.profile.twitter
        this.linkedin = profileData.profile.linkedin
        this.othermail = profileData.profile.other_mail
        if(profileData.profile.date_of_birth){
          let newDate = (profileData.profile.date_of_birth).split('-');
          newDate = newDate[0] + "/" + newDate[1] + "/" + newDate[2];
          newDate = new Date(newDate);
          newDate = newDate.formatFieldDate();
          this.date_of_birth = newDate;
        }
        this.proInfoData = profileData.profile.professional_info
        for (var i = 0; i < this.proInfoData.length; i++) {
          this.proInfoDetails = this.proInfoData[i];
          if(this.proInfoDetails.key == 'area_of_work'){
            this.skillInfo.area_of_work = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'organization'){
            this.skillInfo.organization = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'degree'){
            this.skillInfo.degree = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'work_domain'){
            this.skillInfo.work_domain = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'work_domain'){
            this.skillInfo.work_domain = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'work_type'){
            this.skillInfo.work_type = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'school'){
            this.skillInfo.school = this.proInfoDetails.value
          }
          if(this.proInfoDetails.key == 'professional_skill'){
            if(this.proInfoDetails.value){
              let professionalSkill = JSON.parse(this.proInfoDetails.value)
              this.skillInfo.professional_skill = professionalSkill
            }
          }
          if(this.proInfoDetails.key == 'academic_skill'){
            if(this.proInfoDetails.value){
              let academicSkill = JSON.parse(this.proInfoDetails.value)
              this.skillInfo.academic_skill = academicSkill
            }
          }
        }
      }
    }
  },
}
